var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_4175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5021 12.1245L8.20605 11.2072V18.1905L10.5007 19.1257C10.5746 16.4693 10.5406 14.4513 10.5021 12.1245Z",
    fill: "#E3DCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.396 12.481L10.5025 12.1245C10.5409 14.4513 10.5749 16.4693 10.501 19.1257L11.3768 19.4822C11.3768 19.4702 11.3812 19.4598 11.3812 19.4479C11.4523 16.9108 11.4315 14.7212 11.396 12.481Z",
    fill: "#F89DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6656 12.4034L14.7733 13.8293L11.3942 12.481C11.4283 14.7227 11.4505 16.9108 11.3794 19.4478C11.3794 19.4598 11.3765 19.4702 11.375 19.4821L14.7733 20.8663L18.7248 19.1615C18.7026 19.1078 18.6893 19.0496 18.6893 18.987L18.6656 12.4019V12.4034Z",
    fill: "#E3DCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5769 18.7961L21.9292 17.7818V11.2072L19.5518 12.0783L19.5769 18.7961Z",
    fill: "#E3DCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5519 12.0275V12.0782L19.577 18.796L18.7264 19.1629C18.7042 19.1093 18.6909 19.0511 18.6909 18.9884L18.6672 11.7501L12.2598 9.59486L13.4226 9.37561L19.5534 11.4279V12.0275H19.5519Z",
    fill: "#F89DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9293 17.7819L14.7732 20.8678V12.9792L8.20605 10.3601L14.4966 9.17285",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3202 11.8273C23.9777 11.9296 24.5852 12.3164 24.954 12.8694C25.3228 13.4223 25.4517 14.1341 25.2985 14.7867C25.2126 15.1535 25.0132 15.5276 24.6668 15.6736C24.3204 15.8197 23.8336 15.6088 23.8195 15.2326C23.8047 14.8192 24.3056 14.5829 24.7189 14.5718C25.5979 14.5478 26.4661 15.0548 26.8785 15.8297C27.291 16.6046 27.227 17.6166 26.7218 18.342",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40153 9.82324C5.60855 10.6346 5.11886 11.7398 5.04933 12.8749C5.03601 13.0986 5.04045 13.3343 5.14697 13.5297C5.25349 13.725 5.49316 13.8653 5.70175 13.7877C5.94438 13.6997 6.01835 13.3581 5.89556 13.1299C5.77277 12.9017 5.51535 12.7794 5.26088 12.7317C4.70314 12.6288 4.09953 12.848 3.73411 13.2851C3.36869 13.7221 3.25773 14.3589 3.45154 14.8959",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.416 7.1209C19.2457 6.62308 19.5817 6.04999 20.0688 5.85968C20.556 5.66937 21.1288 5.80719 21.5616 6.11009C21.8135 6.28655 22.0354 6.53148 22.0976 6.83064C22.1597 7.12979 22.0126 7.483 21.7222 7.57566C21.2876 7.7158 20.8652 7.16075 20.9881 6.72151C21.1111 6.28226 21.5737 6.01961 22.0236 5.93814C23.2304 5.71708 24.5445 6.59376 24.8072 7.79825",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64483 2.22176C6.12357 2.2729 5.74476 2.81928 5.77457 3.34291C5.80439 3.86653 6.16851 4.3342 6.62175 4.60314C6.88534 4.76 7.20133 4.86141 7.49796 4.79302C7.79459 4.72463 8.05264 4.44472 8.017 4.14045C7.96296 3.6845 7.28496 3.52847 6.93784 3.82613C6.59072 4.1238 6.54576 4.65227 6.65933 5.09816C6.96039 6.29297 8.30165 7.12908 9.50032 6.86878",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70118 9.0411C5.79392 7.70955 3.0358 7.72997 1.11923 9.08817",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9746 -2.45581C12.2024 -0.33189 13.4733 1.65332 15.3004 2.73467",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5601 0.111633C20.3323 2.23555 19.0615 4.22076 17.2344 5.30211",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.959 3.39909C15.6363 3.74363 15.3685 4.02404 15.0386 6.44924C14.7086 4.02404 14.4409 3.74512 12.1182 3.39909C14.4409 3.05455 14.7086 2.77414 15.0386 0.348938C15.3685 2.77414 15.6363 3.05306 17.959 3.39909Z",
    fill: "#21187F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85661 17.8972C6.13931 17.8972 6.36849 17.6662 6.36849 17.3812C6.36849 17.0962 6.13931 16.8651 5.85661 16.8651C5.5739 16.8651 5.34473 17.0962 5.34473 17.3812C5.34473 17.6662 5.5739 17.8972 5.85661 17.8972Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.006 10.8554C23.2887 10.8554 23.5179 10.6243 23.5179 10.3393C23.5179 10.0543 23.2887 9.82324 23.006 9.82324C22.7233 9.82324 22.4941 10.0543 22.4941 10.3393C22.4941 10.6243 22.7233 10.8554 23.006 10.8554Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5025 12.1246L10.501 11.1059L18.2354 9.44281L19.5773 9.65759L11.4271 11.6443L11.396 12.481L10.5025 12.1246Z",
    fill: "#F89DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0988 10.3407C15.0988 10.3407 13.6253 6.75506 12.4757 7.80509C11.3262 8.85512 15.0988 10.3407 15.0988 10.3407Z",
    stroke: "#F89DBD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0986 10.3407C15.0986 10.3407 16.5721 6.75506 17.7217 7.80509C18.8712 8.85512 15.0986 10.3407 15.0986 10.3407Z",
    stroke: "#F89DBD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_4175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBox);
export default __webpack_public_path__ + "static/media/GiftBox.068793f7f5e592e6c32090c1817599a6.svg";
export { ForwardRef as ReactComponent };